import { render, staticRenderFns } from "./mobile-menu-tray.component.vue?vue&type=template&id=3235682a&"
import script from "./mobile-menu-tray.component.vue?vue&type=script&lang=ts&"
export * from "./mobile-menu-tray.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports